import { AxiosResponse } from "axios";
import { authRequest } from "common/src/utils/request";

/**
 * 更新契約情報
 */
export type rnw01p = {
  /** 契約者その他電話番号 */
  tfRekytl?: string;
  /** 契約者携帯電話番号 */
  tfRekyt2?: string;
  /** 保険商品コード */
  tfRehscd?: string;
  /** 保険プラン */
  tfRehkpl?: string;
  /** 保険料 */
  tfRegkhk?: number;
  /** 払込方法 */
  tfRehkhh?: string;
  /** コンビニ_支払先コンビニコード */
  tfReconv?: string;
  /** 他保険有無 */
  tfRethum?: string;
  /** 他保険会社名 */
  tfRethcm?: string;
  /** 他保険種類 */
  tfRethsr?: string;
  /** 変更日時 */
  tfRehkdt?: number;
};

/**
 * 更新被保険者情報
 */
export type rnw02p = {
  /** 被保険者その他電話番号 */
  tfRhhktl?: string;
  /** 被保険者携帯電話番号 */
  tfRhhkt2?: string;
  /** 変更日時 */
  tfRhhkdt?: number;
};

/**
 * セキュリティ
 */
export type security = {
  /** 本人確認UUID */
  tfHnuuid?: string;
};

/**
 * API0670 更新契約手続き リクエストインターフェース
 */
export type renewalSubmitRequest = {
  rnw01p: rnw01p;
  rnw02p: rnw02p;
  security: security;
};

/**
 * API0670 更新契約手続き レスポンスインターフェース
 */
export type renewalSubmitResponse = {
  /** コンビニ_オーダーID */
  tfReodid: string;
  /** コンビニ_支払先コンビニコード */
  tfReconv: string;
  /** コンビニ_確認番号 */
  tfRecono: string;
  /** コンビニ_受付番号 */
  tfRereno: string;
  /** コンビニ_支払期限日時 */
  tfRepydt: string;
  /** コンビニ_払込表等URL */
  receiptUrl: string;
};

/**
 * API0670 更新契約手続き
 * @param req
 * @returns
 */
export const postRenewalChange = async (req: renewalSubmitRequest): Promise<AxiosResponse<renewalSubmitResponse>> => {
  return await authRequest.post("/v1/user/renewal", req);
};
